module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./RemindTimeView.js"));
	}, "RemindTimeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RemindTimeView!./src/pages/Promote/Schedule/NewAdd/RemindTime/RemindTimeView.js
// module id = 1671
// module chunks = 418